export enum MainContentAreas {
  Orders = "Orders"
}
